import _Object$fromEntries from "@babel/runtime-corejs3/core-js/object/from-entries";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _Object$entries from "@babel/runtime-corejs3/core-js/object/entries";
import React from "react";
const useActionCreators = (creators, dispatch) => React.useMemo(() => {
  var _context;
  return _Object$fromEntries(_mapInstanceProperty(_context = _Object$entries(creators)).call(_context, _ref => {
    let [name, creator] = _ref;
    return [name, function () {
      return dispatch(creator(...arguments));
    }];
  }));
}, [dispatch, creators]);
export default useActionCreators;